import * as campaignActions from './campaign-actions';
import * as campaignsActions from './campaigns-actions';
import * as getters from './getters';
import { state, mutations } from './mutations';

export default {
  actions: {
    ...campaignsActions,
    ...campaignActions,
  },
  getters,
  state,
  mutations
}